// extracted by mini-css-extract-plugin
export default {"client":"styles_client__Z3G2Q","item":"styles_item__Lc4yX"};